import Layout from '../../components/ui/Layout';
import { useAuth } from '../../context/AuthContext';
import { IconCheck, IconCreditCard } from '@tabler/icons-react';

export default function BillingSettings() {
  const { org } = useAuth();

  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)' }}>
        <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 4 }}>Billing</h1>
        <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 28 }}>Manage your plan and payment details</p>

        {/* Current plan */}
        <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '20px 24px', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 400, color: 'var(--color-text-tertiary)', letterSpacing: '0.05em', marginBottom: 4 }}>CURRENT PLAN</div>
              <div style={{ fontSize: 22, fontWeight: 400, color: 'var(--color-text-primary)' }}>Professional</div>
            </div>
            <button style={{ background: 'var(--color-brand)', color: '#fff', border: 'none', borderRadius: 'var(--radius-md)', padding: '8px 16px', fontSize: 13, cursor: 'pointer' }}>
              Upgrade to Enterprise
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 16, paddingBottom: 16, borderBottom: '0.5px solid var(--color-border-light)' }}>
            {[
              { label: 'Branches', value: '4 of 4' },
              { label: 'Users', value: '38 of 50' },
              { label: 'Next billing date', value: '1 Jul 2026' },
            ].map(s => (
              <div key={s.label}>
                <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', marginBottom: 4 }}>{s.label}</div>
                <div style={{ fontSize: 14, fontWeight: 400, color: 'var(--color-text-primary)' }}>{s.value}</div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {['Daily checks', 'Fuel management', 'Crash detection', 'Group overview', 'DVLA integration', 'PDF reports'].map(f => (
              <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: 'var(--color-success)' }}>
                <IconCheck size={13} stroke={2} /> {f}
              </div>
            ))}
          </div>
        </div>

        {/* Payment method */}
        <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '20px 24px', marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 14 }}>Payment method</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
            <div style={{ width: 44, height: 30, background: 'var(--color-bg-secondary)', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '0.5px solid var(--color-border-light)' }}>
              <IconCreditCard size={18} color="var(--color-text-secondary)" stroke={1.5} />
            </div>
            <div>
              <div style={{ fontSize: 13, color: 'var(--color-text-primary)' }}>Visa ending in 4242</div>
              <div style={{ fontSize: 12, color: 'var(--color-text-tertiary)' }}>Expires 09/28</div>
            </div>
            <button style={{ marginLeft: 'auto', background: 'transparent', color: 'var(--color-text-secondary)', border: '0.5px solid var(--color-border-medium)', borderRadius: 'var(--radius-md)', padding: '5px 12px', fontSize: 12, cursor: 'pointer' }}>Update</button>
          </div>
          <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', display: 'flex', alignItems: 'center', gap: 4 }}>
            Secured by Stripe · All payments are encrypted
          </div>
        </div>

        {/* Invoice history */}
        <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
          <div style={{ padding: '14px 20px', borderBottom: '0.5px solid var(--color-border-light)', fontSize: 14, fontWeight: 400 }}>Invoice history</div>
          {[
            { date: '1 Jun 2026', amount: '£189.00', status: 'Paid' },
            { date: '1 May 2026', amount: '£189.00', status: 'Paid' },
            { date: '1 Apr 2026', amount: '£189.00', status: 'Paid' },
          ].map((inv, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', padding: '13px 20px', borderBottom: i < 2 ? '0.5px solid var(--color-border-light)' : 'none' }}>
              <div style={{ flex: 1, fontSize: 13, color: 'var(--color-text-primary)' }}>{inv.date}</div>
              <div style={{ fontSize: 13, color: 'var(--color-text-primary)', marginRight: 16 }}>{inv.amount}</div>
              <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: 'var(--color-success-light)', color: 'var(--color-success)', marginRight: 12 }}>{inv.status}</span>
              <span style={{ fontSize: 12, color: 'var(--color-brand)', cursor: 'pointer' }}>Download</span>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
